import React, {useMemo} from 'react';

import {SUPPORTED_MEDIA_TYPES} from '../../PanelMediaBrowser/useGetIsMediaPanelSettingsDrawerSupportedForPanel';
import {
  SECTION_LINE_PLOT_SETTINGS_DESCRIPTION,
  SECTION_MEDIA_SETTINGS_DESCRIPTION,
} from './constants';
import {useSectionSettingsContext} from './SectionSettingsContextProvider';
import {SettingsDrawerWrapper} from './SettingsDrawerWrapper';
import {SettingsMenuItem} from './SettingsMenuItem';

export enum SelectedSectionSettingType {
  LinePlot = 'line-plot',
  Media = 'media',
}

export const SectionSettingsMenu = ({
  setSelectedSettingType,
}: {
  setSelectedSettingType: (type: SelectedSectionSettingType) => void;
}) => {
  const {mediaCardTypes} = useSectionSettingsContext();
  const hasSupportedMediaCardType = useMemo(
    () =>
      mediaCardTypes.some(mediaCardType =>
        SUPPORTED_MEDIA_TYPES.includes(mediaCardType)
      ),
    [mediaCardTypes]
  );
  return (
    <SettingsDrawerWrapper title="Section settings">
      <SettingsMenuItem
        dataTest="section-settings-line-plot-menu-item"
        icon="line-plot-alt2"
        color="blue"
        title="Line plots"
        description={SECTION_LINE_PLOT_SETTINGS_DESCRIPTION}
        onClick={() =>
          setSelectedSettingType(SelectedSectionSettingType.LinePlot)
        }
      />
      {hasSupportedMediaCardType && (
        <SettingsMenuItem
          dataTest="section-settings-media-menu-item"
          icon="photo"
          color="purple"
          title="Media settings"
          description={SECTION_MEDIA_SETTINGS_DESCRIPTION}
          onClick={() =>
            setSelectedSettingType(SelectedSectionSettingType.Media)
          }
        />
      )}
    </SettingsDrawerWrapper>
  );
};
